// TODO: Move all query keys into constant
export const QUERYKEYS = {
  // governance
  getUserGovernanceDeposits: (walletPublicKey: string) => {
    return ["user", walletPublicKey, "governance", "deposits"];
  },
};
